module.exports = __webpack_public_path__ + "static/thanksgiving-83a16971ee09dd72b41b073c331c45c7.jpg";